import * as tslib_1 from "tslib";
var _a, _b, _c;
export var TRIGGER_EVENT = {
    RIDER_BUSY: 'rider_busy',
    RIDER_REJECT: 'rider_reject',
    CUSTOMER_CANCELLED: 'customer_cancelled',
    RIDER_CANCELLED: 'rider_cancelled',
    ABORTED: 'aborted',
    ACCEPTED: 'accepted',
    FEEDBACK_FOR_CAPTAIN_RECEIVED: 'feedback_for_captain_received',
    LIVE_FEEDBACK_FROM_CUSTOMER_RECEIVED: 'live_feedback_from_customer_received',
    DROPPED: 'dropped',
    DROPPED_SPD: 'dropped_spd',
    DROPPED_RTO: 'dropped_rto',
    RATING: 'rating_for_captain_received',
    OFFLINE_RIDE: 'offlineRide',
    OVERALL_RATING: 'overall_rating',
    APR: 'apr',
    DPR: 'dpr',
    RIDER_SWITCH: 'switch_rider',
    TRUE_DPR: 'trueDPR',
    CAPTAIN_CANCELLATIONS: 'captainCancellations',
    CCR: 'ccr',
    ESCALATION_TICKET: 'escalation_ticket',
    PARTIAL_OFFLINE_RIDE: 'partial_offline_ride',
    POR_CUSTOMER_CONTINUED_RIDE: 'partial_offline_ride_customer_continued_response',
    RIDER_OR_CUSTOMER_CANCELLED: 'rider_or_customer_cancelled',
    IVR_ABORTED: 'ivr_aborted',
    IVR_STARTED: 'ivr_started',
    IVR_DROPPED: 'ivr_dropped',
    IVR_CUSTOMER_CANCELLED: 'ivr_customer_cancelled',
};
export var CAMPAIGN_TYPE = {
    captainGame: 'Captain Game',
    penaltyAndReward: 'Penalty & Reward',
};
export var RATING_POSITION = {
    START: 'start',
    END: 'end',
    SINGLE: 'single'
};
export var RATING_TRIGGERS = [
    TRIGGER_EVENT.RATING,
];
export var eventsWithoutReasons = [
    TRIGGER_EVENT.RIDER_BUSY,
    TRIGGER_EVENT.ACCEPTED,
    TRIGGER_EVENT.RIDER_REJECT,
    TRIGGER_EVENT.DROPPED,
    TRIGGER_EVENT.DROPPED_SPD,
    TRIGGER_EVENT.DROPPED_RTO,
    TRIGGER_EVENT.APR,
    TRIGGER_EVENT.DPR,
    TRIGGER_EVENT.OVERALL_RATING,
    TRIGGER_EVENT.CCR,
    TRIGGER_EVENT.TRUE_DPR,
    TRIGGER_EVENT.CAPTAIN_CANCELLATIONS,
    TRIGGER_EVENT.POR_CUSTOMER_CONTINUED_RIDE,
    TRIGGER_EVENT.RIDER_OR_CUSTOMER_CANCELLED,
];
export var aprDprEvents = [
    TRIGGER_EVENT.APR,
    TRIGGER_EVENT.DPR
];
export var EVENT_REASON_TYPE = {
    MULTI_SELECT: "multiSelect",
    SINGLE_SELECT: "singleSelect",
    RANGE: "range",
    NO_REASON: "noReason",
};
export var EQUATION_TYPES = {
    LESS_THAN: "Less than",
    GREATER_THAN: "Greater than",
    BETWEEN: "Between",
};
export var RULE_KEY_MAPPINGS = {
    ruleName: 'Rule Name',
    ruleId: 'Rule ID',
    startDate: 'Start Date',
    endDate: 'End Date',
    cityId: 'City',
    serviceDetails: 'Service',
    rules: 'Rules',
    timeWindows: 'Time Windows',
    rollingWindowDays: 'Rolling window days',
    event: 'Event',
    leeway: 'Leeway',
    leewayWarnMsg: 'Leeway message',
    instanceLeeway: 'Instance Leeway',
    instanceLeewayWarnMsg: 'Instance Leeway message',
    userSelectors: 'User Selector',
    active: "Active",
    starCaptainEligibility: 'Star Captain Eligibility',
};
export var NUDGE_NOTIFICATION = {
    notifType: 'NUDGE',
    displayText: 'Nudge',
};
export function withNudgeNotification(notifications) {
    if (notifications === void 0) { notifications = []; }
    var list = Array.isArray(notifications) ? notifications.slice() : [];
    if (!list.some(function (notification) { return notification && notification.notifType === NUDGE_NOTIFICATION.notifType; })) {
        list.push(tslib_1.__assign({}, NUDGE_NOTIFICATION));
    }
    return list;
}
export var EVENT_NAME_MAPPINGS = (_a = {
        'rider_busy': 'Rider Busy',
        'rider_reject': 'Rider Reject',
        'customer_cancelled': 'Customer Cancelled',
        'aborted': 'Aborted',
        'accepted': 'Accepted',
        'feedback_for_captain_received': 'Captain Feedback',
        'live_feedback_from_customer_received': 'Report Feedback',
        'dropped': 'Dropped',
        'rating_for_captain_received': 'Rating',
        'offlineRide': 'Offline ride Identified',
        'overall_rating': 'Overall Rating',
        'apr': 'Accept to Ping Ratio',
        'dpr': 'Drop to Ping Ratio',
        'switch_rider': 'Rider Switch',
        'streak': 'Streak',
        'trueDPR': 'True DPR',
        'captainCancellations': 'Captain Cancellations',
        'ccr': 'CCR%',
        'escalation_ticket': 'Escalation Ticket'
    },
    _a[TRIGGER_EVENT.DROPPED_SPD] = "Dropped SPD",
    _a[TRIGGER_EVENT.DROPPED_RTO] = "RTO DROPPED",
    _a['partial_offline_ride_customer_continued_response'] = 'POR Customer Continued Response',
    _a['rider_or_customer_cancelled'] = 'Rider or Customer Cancelled',
    _a['ivr_aborted'] = 'IVR Aborted',
    _a['ivr_started'] = 'IVR Started',
    _a['ivr_dropped'] = 'IVR Dropped',
    _a['ivr_customer_cancelled'] = 'IVR Customer Cancelled',
    _a);
export var EVENT_REASON_TYPES = (_b = {},
    _b[TRIGGER_EVENT.RIDER_REJECT] = EVENT_REASON_TYPE.NO_REASON,
    _b[TRIGGER_EVENT.ACCEPTED] = EVENT_REASON_TYPE.NO_REASON,
    _b[TRIGGER_EVENT.RIDER_BUSY] = EVENT_REASON_TYPE.NO_REASON,
    _b[TRIGGER_EVENT.DROPPED] = EVENT_REASON_TYPE.NO_REASON,
    _b[TRIGGER_EVENT.OFFLINE_RIDE] = EVENT_REASON_TYPE.MULTI_SELECT,
    _b[TRIGGER_EVENT.ABORTED] = EVENT_REASON_TYPE.MULTI_SELECT,
    _b[TRIGGER_EVENT.CUSTOMER_CANCELLED] = EVENT_REASON_TYPE.MULTI_SELECT,
    _b[TRIGGER_EVENT.FEEDBACK_FOR_CAPTAIN_RECEIVED] = EVENT_REASON_TYPE.MULTI_SELECT,
    _b[TRIGGER_EVENT.RIDER_SWITCH] = EVENT_REASON_TYPE.MULTI_SELECT,
    _b[TRIGGER_EVENT.RATING] = EVENT_REASON_TYPE.SINGLE_SELECT,
    _b[TRIGGER_EVENT.ESCALATION_TICKET] = EVENT_REASON_TYPE.MULTI_SELECT,
    _b[TRIGGER_EVENT.RIDER_CANCELLED] = EVENT_REASON_TYPE.MULTI_SELECT,
    _b[TRIGGER_EVENT.LIVE_FEEDBACK_FROM_CUSTOMER_RECEIVED] = EVENT_REASON_TYPE.MULTI_SELECT,
    _b[TRIGGER_EVENT.IVR_ABORTED] = EVENT_REASON_TYPE.MULTI_SELECT,
    _b[TRIGGER_EVENT.IVR_STARTED] = EVENT_REASON_TYPE.MULTI_SELECT,
    _b[TRIGGER_EVENT.IVR_DROPPED] = EVENT_REASON_TYPE.MULTI_SELECT,
    _b[TRIGGER_EVENT.IVR_CUSTOMER_CANCELLED] = EVENT_REASON_TYPE.MULTI_SELECT,
    _b);
export var INSTANCE_LEEWAY_EVENTS = [
    'apr',
    'dpr',
    'overall_rating',
    'ccr'
];
export var EVENT_KEY_VALUES = [
    { value: 'rider_reject', label: 'Rider Reject' },
    { value: 'rider_busy', label: 'Rider Busy' },
    { value: 'accepted', label: 'Rider Accepted' },
    { value: 'rider_cancelled', label: 'Rider Cancelled' },
    { value: 'aborted', label: 'Rider Abort' },
    { value: 'dropped', label: 'Dropped' },
    { value: 'offlineRide', label: 'Offline Ride Identified' },
];
export var STAR_CAPTAIN_ELIGIBILITY_SEGMENT = 'STAR_CAPTAIN';
export var CAPTAIN_ELIGIBILITY_SEGMENT_KEY_VALUES = [
    { value: 'CHURNED', label: 'Churned' },
    { value: 'HH', label: 'HandHolding' },
    { value: 'RECENT_UNDERPERFORMING', label: 'Recent Underperforming' },
    { value: 'RECENT_MIDPERFORMING', label: 'Recent Midperforming' },
    { value: 'RECENT_HIGHPERFORMING', label: 'Recent Highperforming' },
    { value: 'DORMANT_UNDERPERFORMING', label: 'Dormant Underperforming' },
    { value: 'DORMANT_MIDPERFORMING', label: 'Dormant Midperforming' },
    { value: 'DORMANT_HIGHPERFORMING', label: 'Dormant Highperforming' },
    { value: 'INACTIVE_UNDERPERFORMING', label: 'Inactive Underperforming' },
    { value: 'INACTIVE_MIDPERFORMING', label: 'Inactive Midperforming' },
    { value: 'INACTIVE_HIGHPERFORMING', label: 'Inactive Highperforming' }
];
export var ACTIONS = {
    WARNING: 'warning',
    PENALTY: 'penalty',
    REWARD: 'reward',
    SUSPEND: 'suspend',
    SERVICE_SUSPEND: 'serviceSuspend',
    DEPRIORITIZE: 'deprioritize',
    DEACTIVATION: 'deactivation',
    ADJUSTMENT: 'adjustment',
    PUSH_TO_AGENT: 'pushToAgent',
    TRAINING: 'training',
    GEMS_REWARD: 'gemsReward',
    OUTBOUND_CALL: 'outboundCall',
};
export var ACTION_DISPLAY_LABELS = (_c = {},
    _c[ACTIONS.SUSPEND] = 'suspend (subServiceType)',
    _c[ACTIONS.OUTBOUND_CALL] = 'outbound call',
    _c);
export function formatActionDisplayLabel(action) {
    return ACTION_DISPLAY_LABELS[action] || action;
}
export var AI_CALL_NOTIFICATION_TYPE = 'AI_CALL';
export var EVALUATION_MODE_INSTANT = 'instant';
export var EVALUATION_MODE_AGGREGATE = 'aggregate';
export var EVALUATION_MODE_OPTIONS = [
    { value: EVALUATION_MODE_INSTANT, label: 'Instant' },
    { value: EVALUATION_MODE_AGGREGATE, label: 'Aggregate' },
];
export function applyOutboundCallConfig(controls, cfg) {
    if (!cfg) {
        return;
    }
    controls.aiCallRetryEnabled.value = !!(cfg.retry && typeof cfg.retry.count === 'number');
    controls.aiCallRetryCount.value = cfg.retry && cfg.retry.count;
}
export function buildOutboundCallConfig(rule) {
    var config = {};
    if (rule.aiCallRetryEnabled) {
        config.retry = { count: Number(rule.aiCallRetryCount) };
    }
    return config;
}
export var defaultLocale = { code: 'en', label: 'English' };
export var supportedLocales = [
    { code: 'en', label: 'English' },
    { code: 'hi', label: 'Hindi' },
    { code: 'te', label: 'Telugu' },
    { code: 'ta', label: 'Tamil' },
    { code: 'kn', label: 'Kannada' },
    { code: 'mr', label: 'Marathi' },
    { code: 'bn', label: 'Bengali' },
];
export var PARTIAL_OFFLINE_RIDE_KEY = "dropVerificationStatus";
export var BLACKLISTED_TRIGGER_EVENTS_WITH_DROPPED_OFFLINE = { DROPPED: TRIGGER_EVENT.DROPPED, DROPPED_SPD: TRIGGER_EVENT.DROPPED_SPD };
export var BLACKLISTED_TRIGGER_EVENTS_WITH_POR_CUSTOMER_CONTINUED_RIDE = { CAPTAIN_FEEDBACK: TRIGGER_EVENT.FEEDBACK_FOR_CAPTAIN_RECEIVED, ESCALATION_TICKET: TRIGGER_EVENT.ESCALATION_TICKET, LIVE_FEEDBACK: TRIGGER_EVENT.LIVE_FEEDBACK_FROM_CUSTOMER_RECEIVED };
